'use client';

import classNames from 'classnames';
import { FC } from 'react';

import { EventItem, isPastEventEnd } from '@/entities/event';
import {
  formatEventDateRu,
  formatEventTimeRangeRu,
  formatPrice,
} from '@/shared/lib';
import { MODAL_TYPES } from '@/widgets/modals/config/constants';
import { useModalStore } from '@/widgets/modals/model/store';

import styles from './eventPanel.module.scss';

interface EventPanelProps {
  event: EventItem;
  location: string;
  eventSlug?: string;
}

const EventPanel: FC<EventPanelProps> = ({ event, location, eventSlug }) => {
  const { openModal } = useModalStore();
  const registrationClosed = isPastEventEnd(event.end_at);
  const noSeatsLeft = event.available_seats === 0;
  const slug = eventSlug || event.slug;

  const buttonLabel = noSeatsLeft ? 'Хочу в лист ожидания' : 'Записаться';

  const handleClick = () => {
    if (registrationClosed) {
      return;
    }

    const payload = {
      event: {
        slug,
        title: event.title,
        startAt: event.start_at,
        location,
        price: event.price,
      },
    };

    if (noSeatsLeft) {
      openModal(MODAL_TYPES.eventWaitlist, payload);
      return;
    }

    openModal(MODAL_TYPES.eventRegistration, payload);
  };

  return (
    <section className={classNames('container', styles.panel)}>
      <div className={styles.panel__info}>
        <div className={styles.panel__info_item}>
          <p>{formatEventDateRu(event.start_at)}</p>
          <p>{formatEventTimeRangeRu(event.start_at, event.end_at)}</p>
        </div>
        <div className={styles.panel__info_item}>
          <p>{location}</p>
        </div>
        <div
          className={classNames(
            styles.panel__info_item,
            styles['panel__info_item--right'],
          )}
        >
          {!registrationClosed && (
            <p className={styles.panel__price}>{formatPrice(event.price)}</p>
          )}
          {registrationClosed ? (
            <p className={styles.panel__closed}>Запись закрыта</p>
          ) : (
            <button
              className={classNames(
                'button',
                noSeatsLeft ? 'button--md-grey' : 'button--md-black',
                styles.panel__button,
              )}
              type="button"
              onClick={handleClick}
            >
              {buttonLabel}
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default EventPanel;
